export function getHorizontalAlignItems(horizontalAlignment?: 'left' | 'center' | 'right' | null): string {
  switch (horizontalAlignment) {
    case 'left':
      return 'flex-start'
    case 'center':
      return 'center'
    case 'right':
      return 'flex-end'
    default:
      return 'flex-start'
  }
}

export function getVerticalFlexAlignItems(verticalAlignment?: 'top' | 'middle' | 'bottom' | null): string {
  switch (verticalAlignment) {
    case 'top':
      return 'start'
    case 'middle':
      return 'center'
    case 'bottom':
      return 'end'
    default:
      return 'center'
  }
}

export function getBackgroundVerticalAlignItems(verticalAlignment?: 'top' | 'middle' | 'bottom' | null): string {
  switch (verticalAlignment) {
    case 'top':
      return 'top'
    case 'middle':
      return 'center'
    case 'bottom':
      return 'bottom'
    default:
      return 'center'
  }
}
